export default {
    ee: {
        bounds: [
            {lat: 57.4647328, lng: 28.1818012},
            {lat: 59.7230611, lng: 27.9805613},
            {lat: 59.4527417, lng: 20.9921533},
            {lat: 57.4088362, lng: 21.9917002}
        ],
        center: {lat: 51.9570078, lng: 17.8513354}
    },
    eeru: {
        bounds: [
            {lat: 57.4647328, lng: 28.1818012},
            {lat: 59.7230611, lng: 27.9805613},
            {lat: 59.4527417, lng: 20.9921533},
            {lat: 57.4088362, lng: 21.9917002}
        ],
        center: {lat: 51.9570078, lng: 17.8513354}
    },
    lv: {
        bounds: [
            {lat: 55.2675131, lng: 20.2741323},
            {lat: 58.5633603, lng: 29.6125113}
        ],
        center: {lat: 57.001046, lng: 24.512809}
    },
    lvru: {
        bounds: [
            {lat: 55.2675131, lng: 20.2741323},
            {lat: 58.5633603, lng: 29.6125113}
        ],
        center: {lat: 57.001046, lng: 24.512809}
    },
    pl: {
        bounds: [
            {lat: 54.8267131, lng: 13.5729803},
            {lat: 55.309406, lng: 24.0474823},
            {lat: 48.7940005, lng: 25.0460633},
            {lat: 48.8418705, lng: 15.8229933}
        ],
        center: {lat: 51.9570078, lng: 17.8513354}
    },
    lt: {
        bounds: [
            {lat: 54.181999, lng: 26.668262},
            {lat: 56.298682, lng: 26.382741},
            {lat: 56.279105, lng: 21.159904},
            {lat: 54.311675, lng: 21.463246}
        ],
        center: {lat: 51.9570078, lng: 17.8513354}
    },
    ua: {
        bounds: [
            {lat: 51.566309447560066, lng: 21.556238369100672},
            {lat: 51.77532104374969, lng: 40.43309626113098},
            {lat: 46.20848351321436, lng: 39.815030583910406},
            {lat: 46.30096642489184, lng: 22.994299118807223}
        ],
        center: {lat: 48.97938858209427, lng: 31.470326541743532}
    }
}